export default "__VITE_ASSET__CrYp4uvQ__"